"use strict";

var isUndefined = require('lodash/isUndefined');

function matches(params) {
  var quantity = params.quantity,
      opts = params.opts;
  var _opts$condition = opts.condition,
      key = _opts$condition.key,
      value = _opts$condition.value,
      from = _opts$condition.from;
  var val;
  var obj;

  if (from) {
    obj = params[from];
  } else {
    // default
    obj = params.component;
  }

  if (key === 'quantity') {
    val = quantity;
  } else {
    val = obj[key];
  }

  if (isUndefined(val)) {
    console.error(obj);
    throw new Error("".concat(key, " returned undefined"));
  }

  var comparator; // we can specify a regular expression in the options with regexp:/<grp1>/<grp2>

  if (String(value).match(/regexp:\/(.*)\/([a-z]*)/)) {
    var matcher = String(value).match(/regexp:\/(.*)\/([a-z]*)/);
    var grp1 = matcher[1];
    var grp2 = matcher[2];
    comparator = new RegExp(grp1, grp2);
  } else {
    comparator = value;
  }

  return val.match(comparator);
}

function match(oldValue, newValue, rest) {
  return matches(rest) ? newValue : oldValue;
}

function notMatch(oldValue, newValue, rest) {
  return matches(rest) ? oldValue : newValue;
}

module.exports = {
  match: match,
  notMatch: notMatch
};